//= require jquery
/* eslint-disable max-lines-per-function */
$(document).ready(() => {
  // Handle shipment toggle button clicks
  $(".shipments-toggle").on("click", function (e) {
    e.preventDefault();

    const $button = $(this);
    const orderId = $button.data("order-id");
    const $detailsRow = $(`.shipment-details-row[data-order-id="${orderId}"]`);
    const isExpanded = $button.data("expanded") === true || $button.data("expanded") === "true";

    if (isExpanded) {
      // Collapse
      $detailsRow.addClass("d-none");
      $button.data("expanded", false);
      $button.removeClass("btn-secondary").addClass("btn-outline-secondary");
    } else {
      // Expand
      $detailsRow.removeClass("d-none");
      $button.data("expanded", true);
      $button.removeClass("btn-outline-secondary").addClass("btn-secondary");
    }
  });

  // Auto-expand orders with multiple shipments on page load
  $(".shipments-toggle").each(function () {
    const $button = $(this);
    const shipmentCount = parseInt($button.find(".badge").text(), 10);

    if (shipmentCount > 1) {
      $button.data("expanded", true);
      $button.removeClass("btn-outline-secondary").addClass("btn-secondary");
    }
  });

  // Add hover effect for shipment items
  $(".shipment-item").hover(
    function () {
      $(this).addClass("shadow-sm");
    },
    function () {
      $(this).removeClass("shadow-sm");
    }
  );

  // Style pending orders
  $("td.pending").addClass("text-muted font-italic");
});
